<div class="d-flex flex-column">
  <ng-container *ngFor="let permission of permissions">
    <base-checkbox
      class="pt-3"
      [isChecked]="permission.isSelected"
      [label]="permissionLabel"
      (getChange)="onPermissionChange($event, permission.id)"
    ></base-checkbox>
    <ng-template #permissionLabel>
      <base-permission-checkbox-template [permission]="permission"></base-permission-checkbox-template>
    </ng-template>
  </ng-container>
</div>
